import { store } from 'v3/data/store';
import { navigationSlice } from 'v3/data/store/contractCard';
import { ContractNavigationEnum } from 'v3/data/store/contractCard/enum';

export const setNavigationStep = (step: ContractNavigationEnum) => {
  store.dispatch(navigationSlice.actions.setNavigationStep(step));
};

export const navigateToNextCard = () => {
  store.dispatch(navigationSlice.actions.navigateToNextCard());
};

export const navigateToPreviousCard = () => {
  store.dispatch(navigationSlice.actions.navigateToPreviousCard());
};
